module.exports = __webpack_public_path__ + "static/media/tazman-logo.2b35e934.webp";